import React from "react";
import { FullPageLayout } from "../layouts/full-page-layout";
import { HeaderAndForm } from "./header-and-form";
import { Statistics } from "./statistics";
import { VideoSection } from "./video-section";
import { ValuationSteps } from "./valuation-steps";
import { BenefitsReviews } from "./benefits-reviews.tsx";
import { PageComponentContainer } from "./page-component-container.tsx";
import { HRDisclaimer } from "./hr-disclaimer.tsx";
import { DividerWithTip } from "../components/divider/divider-with-tip.tsx";
import { FAQs } from "./faqs.tsx";

export const ValuationsLandingPage: React.FC = () => {
  return (
    <FullPageLayout>
      <div className="flex flex-col items-center">
        <PageComponentContainer>
          <HeaderAndForm />
        </PageComponentContainer>
        <PageComponentContainer additionalOuterStyles={"w-full bg-cloud"} additionalStyles="py-7.5 md:py-7.5 lg:py-7.5">
          <Statistics />
        </PageComponentContainer>
        <PageComponentContainer>
          <VideoSection />
        </PageComponentContainer>
        <PageComponentContainer additionalOuterStyles={"w-full"} additionalStyles={"!p-0"}>
          <DividerWithTip />
        </PageComponentContainer>
        <PageComponentContainer additionalOuterStyles={"w-full"}>
          <ValuationSteps />
        </PageComponentContainer>
        <PageComponentContainer additionalOuterStyles={"w-full bg-cloud"}>
          <BenefitsReviews />
        </PageComponentContainer>
        <PageComponentContainer>
          <div className="flex flex-col gap-[60px] lg:gap-[100px]">
            <div className={"max-w-[820px] w-full mx-auto"}>
              <FAQs />
            </div>
            <HRDisclaimer />
          </div>
        </PageComponentContainer>
      </div>
    </FullPageLayout>
  );
};
